
import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { timesheetreportService } from '../services/timesheetreportsService';
import { timesheetService } from '../services/timesheetService';
import { timesheetuserService } from '../services/timesheetUserservice';
import { formatterhelper } from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import { loader } from '../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch, FaTrash } from "react-icons/fa";
import Smallloader from '../compnents/loader';
import { Mandate } from '../compnents/formcomp';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


const Timesheetapproveadmin = () => {
   const toast = useRef(null);
   const [formData, setFormData] = useState({
      fromdate: '',
      todate: '',
      employee: '',
   });
   const [datacomp, setDatacomp] = useState([]);
   const [rdsdatacomp, setrdsDatacomp] = useState([]);
   const [dataavail, setDatastate] = useState(false);
   const [clientscomp, setClientscomp] = useState([]);
   // const [clientscomp,setClientscomp1] = useState([]); 
   const [subclientscomp, setsubClientscomp] = useState([]);
   const [subtaskscomp, settaskscomp] = useState([]);
   const [subclientLoader, setSubclientloader] = useState(<></>);
   const [empcomp, setempcomp] = useState([]);
   const [totalpages, setPages] = useState(0);
   const [filterobj, setfilterobj] = useState({});

   const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
   const [isloaded, setloading] = useState(true);
   const [first, setFirst] = useState(0);
   const [rows, setRows] = useState(15);
   const [addtimesheettoggle, settoggle] = useState(false);
   const [editobj, seteditobj] = useState(null);
   const [toggleaddform, settoggleaddform] = useState(false);
   const [remainhrsloaded, setremainhrsloaded] = useState(true);
   const [remainloaded, setreminloader] = useState(true);
   const [errors, setErrors] = useState({});
   const [objdata_, setObjdata_] = useState({});
   const [minutestcount,setminutescount] = useState({minutes:0,count:0});
   const [tempdata, setTempdata] = useState([]);
   const [approveId, setApproveId] = useState([]);
   const [isverified,setverification] = useState(true);
   const [tmslists,settmslists] = useState([]);
   const [checkapproveIds, setCheckApproveIds] = useState([]);
   var checkapproveId = [];
   

   const [formData2, setForm2Data] = useState({
      selectedclient: '',
      selectedsubclient: '',
      task: '',
      minutes: '',
      billedminutes: '',
      budgethours: '',
      remainingbudgethours: '',
      count: '',
      fillingfor: '',
      remarks: ''
   });

   const [tmaddformData, tmaddsetFormData] = useState({
      client: '',
      subclient: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      budget_hours: '',
      date: '0',
      querycount: '',
      remaining_hrs: '',
   });

   const [editformData, seteditFormData] = useState({
      client: '',
      subclient: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      taskid: '',
      budget_hours: 0,
      date: 0,
      fillingfor: 0,
      querycount: '',
      remaining_hrs: 0
   });

   useEffect(() => {
      getuserslist();
      _getallclient();
      _gettasks();

      getteammembers();
   }, []);

//    useEffect(() => {
//     console.log(checkapproveId);
//  }, [checkapproveId]);



   useEffect(()=>{
      counterfunction();
   },[tempdata]);

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));

      if (name == 'fromdate' && name == 'todate' && (formData.userid != '')) {
           formData.userid = '';
      }

      if (name == 'employee') {
         let objdata = {
            'date': formatterhelper.dateformatter({ date: formData.fromdate }),
            'todate': formatterhelper.dateformatter({ date: formData.todate }),
            'userid': value
         };
         setObjdata_(objdata);
         selusrtms(objdata);
      }
   };

   // const handleSubmit = (e) => {
   //    e.preventDefault();
   //    let reportobj = {
   //       'frmdt': formatterhelper.dateformatter({ date: formData.fromdate }),
   //       'todt': formatterhelper.dateformatter({ date: formData.todate }),
   //    };

   //    // Now you can perform any further actions with the form data
   // };

   const handleSubmit = (e) => {
      e.preventDefault();
      let reportobj = {
        'ts_ids':checkapproveIds.join(','),
        'userid':formData.employee
      };
      console.log('report object'); 
      console.log(reportobj);
      // approve_tms({obj:reportobj});
      approvalconfirm({obj:reportobj});
      // Now you can perform any further actions with the form data
   };


  function approvalconfirm({obj}){
      confirmDialog({
          message: 'Are you sure you want to proceed?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          defaultFocus: 'accept',
          accept: () => approve_tms_data({obj}),
         //  accept,
          reject
      });
  }



   const tmaddChange = (e) => {
      const { name, value } = e.target;
      tmaddsetFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
      let selected_client = '';
      if (name == 'client') {
         //   setSelectedCateg(value);
         selected_client = value;
         getallsubclients({ client: selected_client });
      }

      if (name == 'subclient') {
         // formData.client;
         // get remainign hours
         getremaining_hrs({ clientid: tmaddformData.client, subclientid: value, ftype: 'add' });
      }
   };

   const getremaining_hrs = ({ clientid, subclientid, ftype }) => {
      setremainhrsloaded(false);
      setreminloader(false);
      if (ftype == 'add') {
         tmaddsetFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      } else {
         seteditFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      }

      timesheetService.getremaining_hrs({ clientid, subclientid }).then((response) => {
         let budget_hours = response.data.budget_hours;
         let remaining_hours = response.data.remaining_hours;

         if (ftype == 'add') {
            tmaddsetFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         } else {
            seteditFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         }
         setremainhrsloaded(true);
         setreminloader(true);
      }).catch((error) => {
         console.log(error);
         setremainhrsloaded(true);
      })
   }


   const validateForm = () => {
      let valid = true;
      const newErrors = {};

      if (!tmaddformData.client.trim()) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (!tmaddformData.subclient.trim()) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }

      if (!tmaddformData.Minutes.trim()) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }

      if (!tmaddformData.Task.trim()) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      //  if (!tmaddformData.date.trim()) {
      //    newErrors.date = 'Date is required';
      //    valid = false;
      //  }

      if (!tmaddformData.Remarks.trim()) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      setErrors(newErrors);
      return valid;
   };

   const tmaddhandleSubmit = (e) => {
      e.preventDefault();
      console.log(tmaddformData);
      if (!validateForm()) {
         return
      }
      addtimesheet({ formdata__: tmaddformData });
      // Now you can perform any further actions with the form data
   };


   function addtimesheet({ formdata__ }) {
      let date = formData.fromdate;
      let todate = formData.todate;
      let formateddate = formatterhelper.dateformatter({ date: date });
      let toformateddate = formatterhelper.dateformatter({ date: todate });
      formdata__.date = formateddate;
      formdata__.todate = toformateddate;
      formdata__.taskid = formdata__.Task;
      formdata__.userid = formData.employee;
      formdata__.hours = formdata__.Minutes;
      // console.log(formateddate);
      // console.log(formdata__);
      // return;
      let formdata_ = JSON.stringify(formdata__);
      timesheetService.newappaddtimesheet({ formdata: formdata_ }).then((response) => {
         console.log(response);
         if (response.status == 200) {
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet added successfully`, life: 3000 });
            selusrtms(objdata_);
            settoggleaddform(false);
            tmaddsetFormData({
               client: '',
               subclient: '',
               BilledMinutes: '',
               Count: '',
               Minutes: '',
               Remarks: '',
               Task: '',
               budget_hours: '',
               date: '0',
               querycount: '',
               remaining_hrs: '',
            });
            // gettimesheetlists({userid:selecteduser});
            // let member = userdata.id;
            // getTimesheets({ selectedmonth: selectedmonth, selectedmember: member }); 
         } else {
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Timesheet not added`, life: 3000 });
         }

      }).catch((error) => {
         toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet added successfully!`, life: 3000 });
         // settoggleaddform(false);
      });
   }


   const handleChangeedittimesheet = (e) => {
      const { name, value } = e.target;
      seteditFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));

      if (name == 'client') {
         let selected_client = e.target.value;
         seteditFormData((prevData) => ({...prevData,client: selected_client}));
         getallsubclients({ client: selected_client });
      }

      if (name == 'subclient') {
         console.log(value);
         console.log("subclient");
         getremaining_hrs({ clientid: editformData.client, subclientid: value, ftype: 'edit' });

         // let selected_client = e.target.value;
         // seteditFormData({client:selected_client}); 
      }
   };

   const validateeditForm = () => {
      let valid = true;
      const newErrors = {};

      if (editformData.client == '' || editformData.client == undefined) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (editformData.subclient == '' || editformData.subclient == undefined) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }

      if (editformData.Minutes == '' || editformData.Minutes == undefined) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }

      if (editformData.Task == '' || editformData.Task == undefined) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      if (editformData.Remarks == '' || editformData.Remarks == undefined) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      setErrors(newErrors);
      return valid;
   };

   const handleSubmitedittimesheet = (e) => {
      e.preventDefault();
      console.log('form data2');
      console.log(editformData);
      if(!validateeditForm()){
          return false;
      }

      let jsondata = JSON.stringify(editformData);
      timesheetService.updateapptimesheet({formdata:jsondata}).then((response) => {
         console.log(response);
         if(response.status == 200){
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet updated successfully`, life: 3000 });
            settoggle(false);   
            selusrtms(objdata_);
         }else{
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Timesheet not updated`, life: 3000 }); 
         }
      }).catch((error) => {
         console.log(error);
         toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Timesheet not updated`, life: 3000 });
      });
   };

   function _getallclient() {
      let emparr = [];
      timesheetService.getallclient().then((response) => {
         // setClients(response.data.data);
         response.data.data.forEach((value, index) => {
            if (value.client != '') {
               emparr.push((<option key={index} value={value.client}>{value.client}</option>));
            }

         });
         setClientscomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   function getallsubclients({ client }) {
      let emparr = [];
      setSubclientloader((<Smallloader />));
      return timesheetService.getallsubclienttemp({ client: client }).then((response) => {
         response.data.data.forEach((value, index) => {
            emparr.push((<option key={index} value={value.subclient}>{value.subclient}</option>));
         });

         setsubClientscomp(emparr);
         setSubclientloader((<></>));
         return response;
      }).catch((error) => {
         console.log(error);
         setSubclientloader((<></>));
      });
   }
   function getuserslist() {
      let emparr = [];
      timesheetuserService.getuserlistbyapprover().then((response) => {
         console.log(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push(<option value={value.id}>{value.name}</option>);
         });
         setempcomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   function _gettasks() {
      let emparr = [];
      timesheetService.gettasks().then((response) => {
         console.log(response.data.data);
         console.log('response get tasks');
         response.data.data.forEach((value, index) => {
            //    console.log(value); 
            //    console.log('response get tasks'); 
            emparr.push((<option value={value.id}>{value.name}</option>));
         });
         settaskscomp(emparr);

      }).catch((error) => {
         console.log(error);
      });
   }

   function getteammembers() {
      let emparr = [];
      let member = userdata.id;
      timesheetService.getteammembers({ managerid: member }).then((response) => {
         console.log(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push(<option value={value.id}>{value.name}</option>);
         });
         setempcomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   const reject = () => {
      toast.current.show({ severity: 'warn', summary: 'Timesheet', detail: 'Canceled', life: 3000 });
    }

   function deletetm(value){

      confirmDialog({
         message: 'Are you sure you want to proceed?',
         header: 'Confirmation',
         icon: 'pi pi-exclamation-triangle',
         defaultFocus: 'accept',
         accept: () => {
            timesheetService.deletetm(value.obj.id).then((response)=>{
               if(response.status == 200){
                  toast.current.show({ severity: 'success', summary: "Timesheet Deletion", detail: `Timesheet deleted successfully`, life: 3000 }); 
                  selusrtms(objdata_);
               }else{
                  toast.current.show({ severity: 'error', summary: "Timesheet Deletion", detail: `Not deleted`, life: 3000 }); 
               }  
            }).catch((error)=>{
               toast.current.show({ severity: 'error', summary: "Timesheet Deletion", detail: `Error`, life: 3000 }); 
            });
         },
        //  accept,
         reject
     });
      // console.log(value.obj.id);
     
   }

   function selusrtms(obj) {
      let emparr = [];
      setloading(false);
      setDatastate(false);
      timesheetService.selusrtms({ obj: obj }).then((response) => {
        if(response.status == 200){
            console.log(response.data.data);
            console.log("response data");
            setTempdata(response.data.data);   
            setApproveId(response.data.data_id);
            setCheckApproveIds([]);
            checkapproveId = [];
            response.data.data.forEach((value, index) => {
               // console.log(value); 
               emparr.push((
                  <tr>
                    <td scope="col">
                        <input type='checkbox' className='' onChange={() => {
                            // console.log(value);
                            approveCheck(value.id);
                        }}
                        // checked={checkapproveIds.includes(value.id)}
                        />
                    </td>
                     <td scope="col">{value.id}</td>
                     <td scope="col">{value.date}</td>
                     <td scope="col">{value.client}</td>
                     <td scope="col">{value.subclient}</td>
                     <td scope="col">{value.taskname}</td>
                     <td scope="col">{value.hours}</td>
                     <td scope="col">{value.billedhours}</td>
                     <td scope="col">{value.count}</td>
                     <td scope="col">{value.remarks}</td>
                     <td scope="col">{value.status == 'Verified' ? (<FaCheck />) : (<><FaEdit className='edit-btn-style custom-cursor-style' onClick={() => openToggle({ obj: value })} /> &nbsp; &nbsp; 
                     <FaTrash className='error custom-cursor-style'  onClick={() => deletetm({ obj: value })}/> </> )}</td>
                  </tr>));
            });
   
            setDatacomp(emparr);
            setloading(true);
            setDatastate(true);
         }else{
            setTempdata([]); 
            setDatacomp([]);
            setloading(true);
            setDatastate(true);
         }
         
      }).catch((error) => {
         console.log(error);
         setTempdata([]);
         setDatacomp([]);
         setloading(true);
         setDatastate(true);
      });
   }

   function openToggle({ obj }) {
      try {
         // obj.Task = '';
         obj.Task = obj.taskid;
         obj.Minutes = obj.hours;
         obj.BilledMinutes = obj.billedhours;
         obj.Remarks = obj.remarks;
         obj.Count = obj.count;

         console.log("object data");
         console.log(obj);

         let objdata = getallsubclients({ client: obj.client });
         console.log("object data");
         console.log(objdata);
         seteditFormData(obj);
         settoggle(true);

         objdata.then((response) => {
            if (response == undefined || response == '') {
               return;
            }
            console.log(response.data.data);
            // return;
            let objselected = {};
            response.data.data.forEach((value, index) => {
               if (obj.subclient == value.subclient) {
                  objselected = value;
               }
            });

            // seteditFormData((prevData)=>({
            //    ...prevData,
            //    date:obj.date
            // })) 

            getremaining_hrs({ clientid: obj.client, subclientid: objselected.subclient, ftype: 'edit' });
         });
      } catch (error) {
         console.log("error");
         console.log(error);
      }
   }

   function approve_tms_data({obj}){
      try{
          timesheetService.approve_tms_data({obj}).then((response)=>{
              console.log("response approve data");    
              console.log(response);  
              if(response.status == 200){
                  if(response.data.isverfied == 'Verified'){
                      setverification(true);
                  }else{
                      setverification(false);
                  }
                  let objdata = {
                     'date': formatterhelper.dateformatter({ date: formData.fromdate }),
                     'todate': formatterhelper.dateformatter({ date: formData.todate }),
                     'userid': formData.employee
                  };
                  setObjdata_(objdata);
                  selusrtms(objdata);;    
                  toast.current.show({ severity: 'success', summary: 'Timesheet', detail: 'Approved Successfully', life: 3000 });  
               }else{
                  setverification(true);
                  settmslists([]);
              } 
          }).catch((error)=>{
              console.log(error);  
              setverification(true);
              settmslists([]);      
          });
      }catch(error){
         console.log(error);
      }
   }


   const remainconditioncomp = (type) => {
      if (type == 'add') {

         let obj = {
            'message': (<></>),
            'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
            'budgethourscomp': (<></>)
         };

         
         if (tmaddformData != undefined) {


            if (tmaddformData.remaining_hrs === 0) {
               obj.message = (<Message className='custom-width-style' severity="info" text="Note : Remaining hours are not available, Chargeable Minutes are not permitted!" />);
               obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
               obj.budgethourscomp = (<></>);
            }
            else if (tmaddformData.budget_hours == '' || tmaddformData.remaining_hrs == '') {
               obj.message = (<Message className='custom-width-style' severity="error" text="Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!" />);
               obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
               obj.budgethourscomp = (<></>);
               obj.remainhourscomp = (<></>);

            } else if (tmaddformData.budget_hours > 0 || tmaddformData.remaining_hrs > 0) {
               obj.budgethourscomp = (<div className='col-md-3'>
                  <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                  <input type='number' disabled="true" value={tmaddformData.budget_hours} name='budget_hours' class="form-control" onChange={(e) => tmaddChange(e)} />
               </div>);

               obj.remainhourscomp = (<div className='col-md-3'>
                  <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                  <input type='number' disabled="true" value={tmaddformData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => tmaddChange(e)} />
               </div>);
            }


            if(userdata.project == 'Bookkeeping'){
               let obj = {
                  'message': (<></>),
                  'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
                  'budgethourscomp': (<></>)
               }; 
               return obj;   
            }
            return obj;
         }
      }

   }


   const remainconditioncompedit = () => {
      let obj = {
         'message': (<></>),
         'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
         'budgethourscomp': (<></>)
      };
      if (editformData.remaining_hrs === 0) {
         obj.message = (<Message className='custom-width-style' severity="info" text="Note : Remaining hours are not available, Chargeable Minutes are not permitted!" />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
         obj.budgethourscomp = (<></>);
      }
      else if (editformData.budget_hours == '' || editformData.remaining_hrs == '') {
         obj.message = (<Message className='custom-width-style' severity="error" text="Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!" />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
         obj.budgethourscomp = (<></>);
         obj.remainhourscomp = (<></>);

      } else if (editformData.budget_hours > 0 || editformData.remaining_hrs > 0) {
         obj.budgethourscomp = (<div className='col-md-3'>
            <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={editformData.budget_hours} name='budget_hours' class="form-control" onChange={(e) => tmaddChange(e)} />
         </div>);

         obj.remainhourscomp = (<div className='col-md-3'>
            <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={editformData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => tmaddChange(e)} />
         </div>);
      }

      if(userdata.project == 'Bookkeeping'){
         let obj = {
            'message': (<></>),
            'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
            'budgethourscomp': (<></>)
         }; 
         return obj;   
      }
      return obj;

   }

   function counterfunction(){
      let totalmin = 0;
      let count = 0;

      console.log('counter function changed');
      
      if(tempdata != undefined && tempdata.length > 0){
         console.log("counter function data lits");
         // console.log(tmslists,"timesshet lists");
         tempdata.forEach((values)=>{
            totalmin = (typeof values.hours === 'number' ? values.hours : 0) + totalmin;
            count = (typeof values.count === 'number' ? values.count : 0)  + count;
         });

         // settimesheetliststemp(data);
         if(tempdata.length <= 0 ){
            setminutescount({minutes:0,count:0});
         }else{
            setminutescount({minutes:totalmin,count:count});
         }
      }
    }

   function fillingforcomp() {
      const today = new Date();
      const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
      let fillingobj = { 'daystr': 'Yesturday', 'dayno': '1' };

      if (dayName == 'Sunday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '2';
      }
      else if (dayName == 'Monday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '3';
      } else {
         fillingobj.daystr = 'Yesturday';
         fillingobj.dayno = '1';
      }

      return fillingobj;
   }

   function allcheck(){
    // console.log(approveId);
    checkapproveId = approveId;
   //  setCheckApproveIds(checkapproveId);
    // setCheckApproveId(approveId);
    // console.log(checkapproveId);
   }

   function approveCheck(id){
    console.log(id);
    console.log(checkapproveId);
    let checked_ids = checkapproveId;
    if(checked_ids.includes(id)){
        checked_ids = checked_ids.filter(item => item !== id);
    }else{
        checked_ids.push(id);
    }
    checkapproveId = checked_ids;
    // console.log(checked_ids);
    console.log(checkapproveId);
    setCheckApproveIds(checked_ids);
   }

   function approveChecks(id){
    checkapproveId.includes(id);
   }

   

   

   return (
      <>
         <Toast ref={toast} />
         <ConfirmDialog />
         <div className="invisible-divider-sm"></div>
         <h6>Timesheet Admin</h6>
         <div className='card card-custom-style card-style-padding'>
            <form onSubmit={handleSubmit}>
               <div className='row'>
                  <div className="col-md-2">
                     <label className='pull-left'><Mandate />From date</label>
                     <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                  </div>
                  <div className="col-md-2">
                     <label className='pull-left'><Mandate />To date</label>
                     <Calendar value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style' />
                  </div>
                  <div className="col-md-2">
                     <label className='pull-left'><Mandate />Select User</label>
                     <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                        <option value="">Select</option>
                        {empcomp}
                     </select>
                  </div>
                  <div className="col-md-3 col-sm-12">
                     <div className='button-wrapper-style'>
                        {formData.employee != '' && formData.fromdate != '' && formData.todate != '' ? (<Button type='submit' stype="button"  label="Approve Timesheet" severity="success" rounded className='custom-btn-style' />) : (<></>)}

                     </div>

                  </div>

                  <div className='col-md-5' style={{aligncontent: 'end'}}>
                        <div className='pagination-style'>Total Count : {minutestcount.minutes} | Count : {minutestcount.count}</div>
                    </div>
               </div>
            </form>
         </div>
         <div className="invisible-divider-sm"></div>
         <div className='card card-custom-style card-style-padding'>
            <div className='row'>
               <div className='col-md-6'></div>
               <div className='pagination col-md-6'>
                  {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
               </div>
            </div>

            <Dialog header="Add Timesheet" visible={toggleaddform} style={{ width: '60vw' }} onHide={() => { settoggleaddform(false) }}>
               <form onSubmit={tmaddhandleSubmit}>
                  <div className='col-md-12'>
                     <div className='row'>
                        <div className='col-md-12'>
                           {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncomp('add').message)}
                           {/* {remainconditioncomp().message} */}
                           <br />
                           <br />
                           {/* <h2>Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!</h2> */}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate />Select Client</label>
                           <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => tmaddChange(e)}>
                              <option value="">select</option>
                              {clientscomp}
                           </select>
                           {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate />Select SubClient</label><span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' required name="subclient" onChange={(e) => tmaddChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subclientscomp}
                           </select>
                           {errors.subclient && <span className='error'>{errors.subclient}</span>}

                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate />Task</label>
                           <select className='custom-dropdown-style' required name="Task" onChange={(e) => tmaddChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subtaskscomp}
                           </select>
                           {errors.Task && <span className='error'>{errors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate />Minutes</label>
                           <input type='number' name="Minutes" required class="form-control" onChange={(e) => tmaddChange(e)} />
                           {errors.Minutes && <span className='error'>{errors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Chargeable Minutes</label>
                           {remainconditioncomp('add').component}
                           {/* <input type='number' name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)}/>   */}
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        {remainconditioncomp('add').budgethourscomp}
                        {/* <div className='col-md-3'>
                        <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>  
                        <input type='number' disabled="true" value={formData.budget_hours}  name='budget_hours' class="form-control" onChange={(e) => handleChange(e)}/>
                     </div> */}
                        {remainconditioncomp('add').remainhourscomp}
                        {/* <div className='col-md-3'>
                        <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                        <input type='number' disabled="true" value={formData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => handleChange(e)}/>  
                     </div> */}
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' class="form-control" onChange={(e) => tmaddChange(e)} />
                        </div>

                        {/* <div className='col-md-3'>
                     <label><Mandate/>Filling For</label>
                     <select className='custom-dropdown-style' value={formData.date} name="date" onChange={(e) => tmaddChange(e)} class="form-control">
                           <option value="0">Today</option>
                           <option value={fillingforcomp().dayno}>{fillingforcomp().daystr}</option>
                        </select> 
                        {errors.date && <span className='error'>{errors.date}</span>} 
                     </div> */}

                        <div className='col-md-6'>
                           <label><Mandate />Remarks</label>
                           <br />
                           <textarea name='Remarks' required onChange={(e) => tmaddChange(e)} class="form-control"></textarea>
                           {/* <input type='text' name='Remarks' onChange={(e) => handleChange(e)} class="form-control"/>   */}
                           {errors.Remarks && <span className='error'>{errors.Remarks}</span>}
                        </div>

                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" onClick={() => settoggleaddform(false)} stype="button" label="Close" severity="danger" rounded />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>


            <Dialog header="Edit Timesheet" visible={addtimesheettoggle} style={{ width: '60vw' }} onHide={() => settoggle(false)}>
               <form onSubmit={handleSubmitedittimesheet}>
                  <div className='col-md-12'>
                     <div className='row'>
                        <div className='col-md-12'>
                           {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncompedit().message)}
                           {/* {remainconditioncomp().message} */}
                           <br />
                           <br />
                           {/* <h2>Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!</h2> */}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate /> Select Client </label>
                           <select className='custom-dropdown-style' required name="client" value={editformData.client} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">select client</option>
                              {clientscomp}
                           </select>
                           {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate /> Select SubClient </label>
                           <span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' required name="subclient" value={editformData.subclient} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">select subclient</option>
                              {subclientscomp}
                           </select>
                           {errors.subclient && <span className='error'>{errors.subclient}</span>}
                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate /> Task</label>
                           <select className='custom-dropdown-style' required name="Task" value={editformData.Task} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">Select Task</option>
                              {subtaskscomp}
                           </select>
                           {errors.Task && <span className='error'>{errors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate /> Minutes</label>
                           <input type='number' name='Minutes' required value={editformData.Minutes} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />
                           {errors.Minutes && <span className='error'>{errors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Billed minutes</label>
                           <input type='number' name='BilledMinutes' value={editformData.BilledMinutes} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        {remainconditioncompedit().budgethourscomp}
                        {remainconditioncompedit().remainhourscomp}
                        {/* <div className='col-md-3'>
                        <label>Budget Hours</label>  
                        <input type='number' name='budget_hours' value={editformData.budget_hours} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>
                     </div>
                     <div className='col-md-3'>
                        <label>Remaining Budget Hours</label>
                        <input type='number' name='remaining_hrs' value={editformData.remaining_hrs} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>  
                     </div> */}
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' value={editformData.Count} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />
                        </div>

                        {/* <div className='col-md-3'>
                     <label>Filling For</label>
                     <select className='custom-dropdown-style' name='fillingfor' value={editformData.fillingfor} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option value="0">Today</option>
                           <option value="1">Yesturday</option>
                        </select> 
                     </div> */}

                        <div className='col-md-6'>
                           <label><Mandate /> Remarks</label>
                           <br />
                           <textarea type='text' required name='Remarks' value={editformData.Remarks} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />
                           {errors.Remarks && <span className='error'>{errors.Remarks}</span>}
                        </div>

                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" label="Close" severity="danger" rounded onClick={() => settoggle(false)} />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>

            <div className='row'>
               {!isloaded ? loader.Loadermd() : dataavail ?
                  (<table class="table table-bordered">
                     <thead>
                        <tr>
                           <th scope="col">
                            {/* <input type='checkbox' className='' onChange={(e) => {
                                allcheck();
                            }}/> */}
                           </th>
                           <th scope="col">Id</th>
                           <th scope="col">Date</th>
                           <th scope="col">Client name</th>
                           <th scope="col">Subclient name</th>
                           <th scope="col">Task</th>
                           <th scope="col">Minutes</th>
                           <th scope="col">Billing Minutes</th>
                           <th scope="col">Count</th>
                           <th scope="col">Remarks</th>
                           <th scope="col">Action</th>
                        </tr>
                     </thead>
                     <tbody>
                        {datacomp}
                     </tbody>
                  </table>) : (<p>No data Found</p>)}
            </div>
            <br />

         </div>

         <div className="invisible-divider-sm"></div>
         {/* <div className="row">
                <h1>table</h1>
            </div> */}
      </>
   );
}

export default Timesheetapproveadmin;

